export const OldDataStructure = {
  generalInfo: {
    isGhgCarbon: null,
    ghgCarbonPrograms: '',
    country: '',
    projectSize: '',
    communitiesAndStakeholders: '',
    subOrTropicalTrees: null,
    treeDensity: '',
    isRelativelyHomogeneous: null,
    positiveImpactsDescription: '',
    yearsInvolved: null,
    continent: null,
    startPlantingActivities: null,
    durationForPlanting: null,
    forestType: null,
    mainTypeOfActivity: '',
  },
  projectActivity: {
    generalPlanning: '',
    sitePreparationActivities: '',
    willZoneBeBurned: '',
    arePestWeedControlUsed: null,
    pestWeedProducts: [{ productName: '', tonnes: '', frequency: null, duration: null }],
    seedlingsComeFrom: '',
    typeOfTreePlantingActivities: '',
    areFertilizersUsed: null,
    fertilizersProducts: [{ productName: '', tonnes: '', frequency: null, duration: null }],
    soilDisturbanceHappen: '',
    isPruningPlanned: '',
    isThinningPlanned: '',
    treeSpeciesNumber: '',
    areExoticSpeciesPlanted: null,
    exoticSpeciesList: '',
    measuresPutInPlace: '',
    intendToDoWithForest: '',
    continueLightGroundMonitoring: null,
  },
  landInfo: {
    whoOwnsTheLand: '',
    landUseOfProjectZone: '',
    wasProjectZoneCleared: null,
    howLandWasCleared: '',
    currentLandUse: '',
    commerciallyUsed: null,
    howZoneIsUsedByCommunities: '',
    involvementInLivelihoodsPrograms: '',
    engagedInAlternativeOptions: '',
    landUseIfZoneNotImplemented: '',
    isLocatedOnPeatlandsOrWetlands: '',
    includeExistingScatteredTrees: null,
  },
  legalAndFinancial: {
    needGovernmentApprove: null,
    envImpactAssessment: null,
    summaryOfImpacts: '',
    areActivitiesLegalRequirement: null,
    activitiesRequirementExplanation: '',
    isTimberHarvestingPlanned: null,
    timberHarvestingExplanation: '',
    projectFinancing: '',
    financingReceived: '',
    enoughFundingToProtect: '',
    viableWithoutCarbonFinancing: '',
    willOFPHelp: null,
    howOFPHelps: '',
  },
  risks: {
    natural: {
      fire: { rating: null, description: '' },
      pestsAndDiseases: { rating: null, description: '' },
      extremeEvents: { rating: null, description: '' },
      extremeDroughts: { rating: null, description: '' },
      animalEncroachment: { rating: null, description: '' },
    },
    socialAndPolitical: {
      disputeOverLandTenureOrOwnership: { rating: null, description: '' },
      politicalAndSocialInstability: { rating: null, description: '' },
      exploitationOfNaturalResources: { rating: null, description: '' },
      lackOfCommunitySupport: { rating: null, description: '' },
    },
    projectManagement: {
      insufficientTechnicalCapacities: { rating: null, description: '' },
      lackOfEquipmentAndMaterial: { rating: null, description: '' },
      lackOfProjectManagement: { rating: null, description: '' },
      relianceOnKeyEmployees: { rating: null, description: '' },
    },
    financial: {
      lackOfSufficientFunding: { rating: null, description: '' },
    },
  },
  contactInfo: {
    projectManagement: {
      organisation: '',
      email: '',
      personName: '',
      phoneNumber: '1', // default country code
    },
    treePlanting: {
      organisation: '',
      email: '',
      personName: '',
      phoneNumber: '1', // default country code
    },
    forestMonitoring: {
      organisation: '',
      email: '',
      personName: '',
      phoneNumber: '1', // default country code
    },
    comments: '',
    documentationComment: '',
    disclaimer: false,
  },
};

export const newDataStructure = {
  generalInfo: {
    isGhgCarbon: null,
    ghgCarbonPrograms: '',
    country: '',
    projectSize: '',
    communitiesAndStakeholders: '',
    subOrTropicalTrees: null,
    treeDensity: '',
    isRelativelyHomogeneous: null,
    positiveImpactsDescription: '',
    yearsInvolved: null,
    continent: null,
    startPlantingActivities: null,
    durationForPlanting: null,
    forestType: null,
    mainTypeOfActivity: '',
  },
  projectActivity: {
    generalPlanning: '',
    sitePreparationActivities: '',
    willZoneBeBurned: '',
    treeSpeciesPlanted: '',
    nonNative: '',
    totalPlantedTree: '',
    arePestWeedControlUsed: null,
    pestWeedProducts: [{ productName: '', tonnes: '', frequency: null, duration: null }],
    seedlingsComeFrom: '',
    typeOfTreePlantingActivities: '',
    areFertilizersUsed: null,
    fertilizersProducts: [{ productName: '', tonnes: '', frequency: null, duration: null }],
    soilDisturbanceHappen: '',
    isPruningPlanned: '',
    isThinningPlanned: '',
    treeSpeciesNumber: '',
    areExoticSpeciesPlanted: null,
    exoticSpeciesList: '',
    measuresPutInPlace: '',
    intendToDoWithForest: '',
    continueLightGroundMonitoring: null,
  },
  landInfo: {
    whoOwnsTheLand: '',
    landUseOfProjectZone: '',
    wasProjectZoneCleared: null,
    howLandWasCleared: '',
    beDisplaced: '',
    currentLandUse: '',
    commerciallyUsed: null,
    howZoneIsUsedByCommunities: '',
    involvementInLivelihoodsPrograms: '',
    engagedInAlternativeOptions: '',
    landUseIfZoneNotImplemented: '',
    isLocatedOnPeatlandsOrWetlands: '',
    includeExistingScatteredTrees: null,
  },
  legalAndFinancial: {
    needGovernmentApprove: null,
    envImpactAssessment: null,
    summaryOfImpacts: '',
    areActivitiesLegalRequirement: null,
    activitiesRequirementExplanation: '',
    isTimberHarvestingPlanned: null,
    timberHarvestingExplanation: '',
    projectFinancing: '',
    financingReceived: '',
    enoughFundingToProtect: '',
    viableWithoutCarbonFinancing: '',
    willOFPHelp: null,
    howOFPHelps: '',
  },
  risks: {
    natural: {
      fire: { rating: null, description: '' },
      pestsAndDiseases: { rating: null, description: '' },
      extremeEvents: { rating: null, description: '' },
      extremeDroughts: { rating: null, description: '' },
      animalEncroachment: { rating: null, description: '' },
    },
    socialAndPolitical: {
      disputeOverLandTenureOrOwnership: { rating: null, description: '' },
      politicalAndSocialInstability: { rating: null, description: '' },
      exploitationOfNaturalResources: { rating: null, description: '' },
      lackOfCommunitySupport: { rating: null, description: '' },
    },
    projectManagement: {
      insufficientTechnicalCapacities: { rating: null, description: '' },
      lackOfEquipmentAndMaterial: { rating: null, description: '' },
      lackOfProjectManagement: { rating: null, description: '' },
      relianceOnKeyEmployees: { rating: null, description: '' },
    },
    financial: {
      lackOfSufficientFunding: { rating: null, description: '' },
    },
  },
  contactInfo: {
    projectManagement: {
      organisation: '',
      email: '',
      personName: '',
      phoneNumber: '1', // default country code
    },
    treePlanting: {
      organisation: '',
      email: '',
      personName: '',
      phoneNumber: '1', // default country code
    },
    forestMonitoring: {
      organisation: '',
      email: '',
      personName: '',
      phoneNumber: '1', // default country code
    },
    comments: '',
    documentationComment: '',
    disclaimer: false,
  },
};
